import { InvestmentsColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/InvestmentsColumns";
import { InvestmentsColumnSetting } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/InvestmentsColumnSetting";
import { PerformanceDetailsColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceDetailsColumns";
import { PerformanceDetailsColumnSetting } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceDetailsColumnSetting";
import { PerformanceIncomeDividendColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceIncomeDividendColumns";
import { PerformanceIncomeDividendColumnSetting } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceIncomeDividendColumnSetting";
import { PerformanceIncomeInterestColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceIncomeInterestColumns";
import { PerformanceIncomeInterestColumnSetting } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceIncomeInterestColumnSetting";
import { PerformanceIncomeTaxColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceIncomeTaxColumns";
import { PerformanceIncomeTaxColumnSetting } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/PerformanceIncomeTaxColumnSetting";
import { RealisedGainLossColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/RealisedGainLossColumns";
import { RealisedGainLossColumnSetting } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/RealisedGainLossColumnSetting";
import { TransactionInvestmentsColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/TransactionInvestmentsColumns";
import { TransactionInvestmentsColumnSetting } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/TransactionInvestmentsColumnSetting";
import { TransactionPaymentsWithdrawalsColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/TransactionPaymentsWithdrawalsColumns";
import { TransactionPaymentsWithdrawalsColumnSetting } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/TransactionPaymentsWithdrawalsColumnSetting";
import { UnRealisedGainLossColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/UnRealisedGainLossColumns";
import { UnRealisedGainLossColumnSetting } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/UnRealisedGainLossColumnSetting";

// Transaction -> Payment / Withdrawals default table editor
const TransactionPaymentsWithdrawalsColumnSettings: TransactionPaymentsWithdrawalsColumnSetting[] = [
    {
        Column: TransactionPaymentsWithdrawalsColumns.Type,
        Enabled: true,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.Products,
        Enabled: true,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.Frequency,
        Enabled: true,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.Method,
        Enabled: true,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.DateCreated,
        Enabled: true,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.Amount,
        Enabled: true,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.Instruction,
        Enabled: true,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.Status,
        Enabled: true,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.ContributionID,
        Enabled: false,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.EntryID,
        Enabled: false,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.PlannManager,
        Enabled: false,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.UniqueID,
        Enabled: false,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.Actions,
        Enabled: false,
    },
    {
        Column: TransactionPaymentsWithdrawalsColumns.Narration,
        Enabled: false,
    },
];

// Investment tab default table editor
const InvestmentsColumnSettings: InvestmentsColumnSetting[] = [
    {
        Column: InvestmentsColumns.Investments,
        Enabled: true,
    },
    {
        Column: InvestmentsColumns.Allocation,
        Enabled: true,
    },
    {
        Column: InvestmentsColumns.TargetAllocation,
        Enabled: false,
    },
    {
        Column: InvestmentsColumns.FundCode,
        Enabled: false,
    },
    {
        Column: InvestmentsColumns.Quantity,
        Enabled: true,
    },
    {
        Column: InvestmentsColumns.Location,
        Enabled: false,
    },
    {
        Column: InvestmentsColumns.UnitCost,
        Enabled: true,
    },
    {
        Column: InvestmentsColumns.UnitPrice,
        Enabled: true,
    },
    {
        Column: InvestmentsColumns.TotalCost,
        Enabled: true,
    },
    {
        Column: InvestmentsColumns.MarketValue,
        Enabled: true,
    },
    {
        Column: InvestmentsColumns.Difference,
        Enabled: true,
    },
    {
        Column: InvestmentsColumns.TreasuredAsset,
        Enabled: true,
    },
];

// Transaction -> Investments default table editor
const TransactionInvestmentsColumnSettings: TransactionInvestmentsColumnSetting[] = [
    {
        Column: TransactionInvestmentsColumns.Date,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.Investments,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.InstrumentCode,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.ProductDisplayName,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.Quantity,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.UnitCost,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.TotalCost,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.TransType,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.Location,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.TransStatus,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.Detail,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.History,
        Enabled: true,
    },
    {
        Column: TransactionInvestmentsColumns.FxCost,
        Enabled: true,
    },
];
const RealisedGainLossColumnSettings: RealisedGainLossColumnSetting[] = [
    {
        Column: RealisedGainLossColumns.AsAt,
        Enabled: true,
    },
    {
        Column: RealisedGainLossColumns.Code,
        Enabled: true,
    },
    {
        Column: RealisedGainLossColumns.Description,
        Enabled: true,
    },
    {
        Column: RealisedGainLossColumns.QtySold,
        Enabled: true,
    },
    {
        Column: RealisedGainLossColumns.Cost,
        Enabled: false,
    },
    {
        Column: RealisedGainLossColumns.CostGBP,
        Enabled: true,
    },
    {
        Column: RealisedGainLossColumns.SalePrice,
        Enabled: false,
    },
    {
        Column: RealisedGainLossColumns.SalePriceGBP,
        Enabled: true,
    },
    {
        Column: RealisedGainLossColumns.RealisedGBP,
        Enabled: true,
    },
];
const UnRealisedGainLossColumnSettings: UnRealisedGainLossColumnSetting[] = [
    {
        Column: UnRealisedGainLossColumns.Code,
        Enabled: true,
    },
    {
        Column: UnRealisedGainLossColumns.Qty,
        Enabled: true,
    },
    {
        Column: UnRealisedGainLossColumns.Cost,
        Enabled: false,
    },
    {
        Column: UnRealisedGainLossColumns.CostGBP,
        Enabled: true,
    },
    {
        Column: UnRealisedGainLossColumns.Price,
        Enabled: false,
    },
    {
        Column: UnRealisedGainLossColumns.PriceGBP,
        Enabled: true,
    },
    {
        Column: UnRealisedGainLossColumns.UnRealisedGBP,
        Enabled: true,
    },
];

const PerformanceIncomeInterestColumnSettings: PerformanceIncomeInterestColumnSetting[] = [
    {
        Column: PerformanceIncomeInterestColumns.CCY,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.Date,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.Code,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.Description,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.Narration,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.Gross,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.Equalisation,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.RWT,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.NET,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.FX,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeInterestColumns.GBPAmount,
        Enabled: true,
    },
];
const PerformanceIncomeDividendColumnSettings: PerformanceIncomeDividendColumnSetting[] = [
    {
        Column: PerformanceIncomeDividendColumns.CCY,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeDividendColumns.Date,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeDividendColumns.Code,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeDividendColumns.Description,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeDividendColumns.Gross,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeDividendColumns.Equalisation,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeDividendColumns.RWT,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeDividendColumns.NET,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeDividendColumns.FX,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeDividendColumns.GBPAmount,
        Enabled: true,
    },
];
const PerformanceIncomeTaxColumnSettings: PerformanceIncomeTaxColumnSetting[] = [
    {
        Column: PerformanceIncomeTaxColumns.CCY,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeTaxColumns.Date,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeTaxColumns.Code,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeTaxColumns.Description,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeTaxColumns.Narration,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeTaxColumns.Tax,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeTaxColumns.FX,
        Enabled: true,
    },
    {
        Column: PerformanceIncomeTaxColumns.TaxGBP,
        Enabled: true,
    },
];

const PerformanceDetailsColumnSettings: PerformanceDetailsColumnSetting[] = [
    {
        Column: PerformanceDetailsColumns.Investment,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.OpeningValue,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.Buys,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.Sells,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.RealisedGainLoss,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.UnRealisedGainLoss,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.Investment,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.Income,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.Gainloss,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.Return,
        Enabled: true,
    },
    {
        Column: PerformanceDetailsColumns.ClosingValue,
        Enabled: true,
    },
];

export const defaultTableColEditor = {
    TransactionPaymentsWithdrawalsColumnSettings: TransactionPaymentsWithdrawalsColumnSettings,
    InvestmentsColumnSettings: InvestmentsColumnSettings,
    TransactionInvestmentsColumnSettings: TransactionInvestmentsColumnSettings,
    RealisedGainLossColumnSettings: RealisedGainLossColumnSettings,
    UnRealisedGainLossColumnSettings: UnRealisedGainLossColumnSettings,
    PerformanceIncomeInterestColumnSettings: PerformanceIncomeInterestColumnSettings,
    PerformanceIncomeDividendColumnSettings: PerformanceIncomeDividendColumnSettings,
    PerformanceIncomeTaxColumnSettings: PerformanceIncomeTaxColumnSettings,
    PerformanceDetailsColumnSettings: PerformanceDetailsColumnSettings,
};

export const TableColSettingKeys = {
    Investments: "InvestmentsColumnSettings",
    TransactionPaymentsWithdrawals: "TransactionPaymentsWithdrawalsColumnSettings",
    RealisedGainLoss: "RealisedGainLossColumnSettings",
    UnRealisedGainLoss: "UnRealisedGainLossColumnSettings",
    IncomeInterest: "PerformanceIncomeInterestColumnSettings",
    IncomeDividend: "PerformanceIncomeDividendColumnSettings",
    IncomeTax: "PerformanceIncomeTaxColumnSettings",
    PerformanceDetails: "PerformanceDetailsColumnSettings",
};
